import { render } from "./HeroiconsOutlineUsers.vue?vue&type=template&id=2bb4513e"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUsers.vue"]])

export default __exports__